(() => {
  'use strict';
  const rules = window.MisakiBlackGiftRules;
  if (!rules) return;
  const language = (document.documentElement.lang || 'de').split('-')[0];
  const words = {
    de: { title: 'Ihr Black Gift', empty: 'Ihr Geschenk ab CHF 100.', next: 'Noch CHF {amount} bis zur nächsten Geschenkstufe.', first: 'Noch CHF {amount} bis zu Ihrem Geschenk.', ready: 'Ihre Geschenkstufe ist erreicht.', all: 'Alle Einkaufsstufen erreicht.', view: 'Geschenke ansehen', choose: 'Geschenk wählen', retry: 'Warenkorb derzeit nicht verfügbar.', currency: 'Black Gifts sind bei Einkäufen in CHF verfügbar.' },
    en: { title: 'Your Black Gift', empty: 'Your gift with purchases from CHF 100.', next: 'CHF {amount} to the next gift tier.', first: 'CHF {amount} to unlock your gift.', ready: 'You have reached a gift tier.', all: 'All purchase tiers reached.', view: 'View gifts', choose: 'Choose your gift', retry: 'Cart currently unavailable.', currency: 'Black Gifts are available for purchases in CHF.' },
    fr: { title: 'Votre Black Gift', empty: 'Votre cadeau dès CHF 100 d’achats.', next: 'Encore CHF {amount} pour le prochain palier.', first: 'Encore CHF {amount} pour votre cadeau.', ready: 'Vous avez atteint un palier cadeau.', all: 'Tous les paliers d’achats sont atteints.', view: 'Voir les cadeaux', choose: 'Choisir votre cadeau', retry: 'Panier momentanément indisponible.', currency: 'Les Black Gifts sont disponibles pour les achats en CHF.' },
    it: { title: 'Il Suo Black Gift', empty: 'Il Suo regalo da CHF 100 di acquisti.', next: 'Mancano CHF {amount} alla prossima soglia regalo.', first: 'Mancano CHF {amount} al Suo regalo.', ready: 'Ha raggiunto una soglia regalo.', all: 'Tutte le soglie di acquisto sono state raggiunte.', view: 'Scoprire i regali', choose: 'Scegliere il regalo', retry: 'Carrello al momento non disponibile.', currency: 'I Black Gift sono disponibili per gli acquisti in CHF.' }
  };
  const copy = words[language] || words.en;
  const emailKey = 'misaki-black-gift-email-session';
  const popupKey = 'misaki-black-gift-popup-dismissed';
  const testKey = 'misaki-black-gift-campaign-session-test';
  const entryKey = 'misaki-black-gift-email-entry-session';
  // Campaign links grant access to the experience, never consent or a gift code.
  let emailEntry = new URLSearchParams(location.search).get('black_gift_source') === 'email';
  try {
    if (emailEntry) sessionStorage.setItem(entryKey, 'true');
    emailEntry = emailEntry || sessionStorage.getItem(entryKey) === 'true';
  } catch {}
  const publicEnabled = document.querySelector('[data-black-gift-progress]')?.dataset.publicEnabled === 'true';
  const giftFormIds = ['TnguMT', 'REmtuQ', 'TduXJ4', 'UnyV9J', 'VxUQTH', 'WF5Fz6', 'Vh6jHe', 'SeCkXv', 'YahMLb'];
  const giftProfiles = {
    UnyV9J: ['credit', 'CHF 25 Gravur-Bonus'], VxUQTH: ['cloth', 'Mikrofasertuch'],
    WF5Fz6: ['oil', 'Kamelienöl'], Vh6jHe: ['sheath_one', 'Eine Walnussholz-Scheide'],
    SeCkXv: ['apron250', 'Küchenschürze'], YahMLb: ['sheath_two', 'Zwei Walnussholz-Scheiden']
  };
  let state = { cart: null, choice: null, message: null };
  const money = cents => (cents / 100).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function enabled() {
    if (publicEnabled) return true;
    try { return sessionStorage.getItem(testKey) === 'true'; } catch { return false; }
  }

  function accessGranted() {
    return Boolean(email() || emailEntry || (state.choice && rules.validCode(state.choice.gift, state.choice.code)));
  }

  function render() {
    const { cart, choice, message } = state;
    document.querySelectorAll('[data-black-gift-session-test]').forEach(control => {
      control.hidden = publicEnabled;
      const button = control.querySelector('[data-black-gift-test-toggle]');
      button.setAttribute('aria-pressed', String(enabled()));
      button.textContent = enabled() ? 'Black Gift für diese Sitzung ausschalten' : 'Black Gift für diese Sitzung aktivieren';
      control.querySelector('[data-black-gift-test-status]').textContent = enabled()
        ? 'Test aktiv. Der Balken erscheint nach Anmeldung oder über einen Kampagnen-E-Mail-Link.' : 'Black Gift ist für diese Sitzung ausgeschaltet.';
    });
    const active = rules.active() && enabled();
    const access = accessGranted();
    document.querySelectorAll('[data-black-gift-access-content]').forEach(content => { content.hidden = !active || !access; });
    document.querySelectorAll('[data-black-gift-access-intro]').forEach(intro => { intro.hidden = !active || access; });
    document.querySelectorAll('[data-black-gift-signup-entry]').forEach(entry => {
      entry.hidden = !active || access || !signup || Boolean(document.querySelector('misaki-black-gift-preview'));
    });
    document.querySelectorAll('[data-black-gift-progress]').forEach(box => {
      box.hidden = !active || !access;
      if (box.hidden) return;
      const progress = box.querySelector('progress');
      const link = box.querySelector('[data-gift-link]');
      const title = box.querySelector('[data-gift-title]');
      const note = box.querySelector('[data-gift-message]');
      const tier = cart ? rules.tierProgress(cart) : { amount: 0, reached: 0, next: 10000 };
      const chf = cart?.currency === 'CHF';
      progress.max = 30000;
      progress.value = chf ? Math.min(30000, tier.amount) : 0;
      box.querySelectorAll('[data-gift-tier]').forEach(marker => marker.classList.toggle('is-reached', chf && tier.amount >= Number(marker.dataset.giftTier)));
      title.textContent = choice && language === 'de'
        ? `${rules.gifts[choice.gift].name} ${choice.gift === 'sheath_two' ? 'sind' : 'ist'} vorgemerkt`
        : copy.title;
      const ready = chf && tier.reached > 0;
      link?.classList.toggle('is-ready', ready);
      if (link) {
        const label = link.querySelector?.('[data-gift-link-label]');
        if (label) label.textContent = ready ? copy.choose : copy.view;
        else link.textContent = ready ? copy.choose : copy.view;
        link.setAttribute('aria-disabled', String(!ready));
        link.tabIndex = ready ? 0 : -1;
      }
      if (!cart) note.textContent = message || copy.retry;
      else if (!chf) note.textContent = copy.currency;
      else if (choice && language === 'de') {
        note.textContent = message || rules.eligibility(cart, choice.gift).reason || copy.ready;
      } else if (!tier.amount) note.textContent = copy.empty;
      else if (tier.next) note.textContent = (ready ? copy.next : copy.first).replace('{amount}', money(tier.next - tier.amount));
      else note.textContent = copy.all;
      window.MisakiBlackGiftProgressView?.render(box, { cart, choice, tier, language });
    });
  }
  document.addEventListener('black-gift:cart', event => { state = event.detail; render(); });
  document.addEventListener('cart:build', () => setTimeout(render, 0));
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => [...mutation.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-black-gift-progress]') || node.querySelector?.('[data-black-gift-progress]'))))) render();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  function email() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(emailKey));
      if (saved && typeof saved.email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(saved.email) && Date.now() - saved.savedAt >= 0 && Date.now() - saved.savedAt < 4 * 60 * 60 * 1000) return saved.email;
      sessionStorage.removeItem(emailKey);
    } catch {}
    return '';
  }
  function prefill(container) {
    const value = email();
    const input = container?.querySelector('input[type="email"]');
    if (!value || !input || input.value || input.dataset.giftPrefilled) return;
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, value);
    input.dataset.giftPrefilled = 'true';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const signup = document.querySelector('[data-black-gift-early-signup]');
  const popupFormId = signup?.dataset.popupFormId;
  const signupStatus = document.querySelector('[data-gift-early-status]');
  let popupTimer;
  let loadTimer;
  let opening = false;
  let popupPending = false;
  let popupOpen = false;
  function anotherDialogVisible() {
    return [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some(element =>
      element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden'
    );
  }
  function dismiss() {
    try { localStorage.setItem(popupKey, String(Date.now())); } catch {}
    clearTimeout(popupTimer);
  }
  function hideSignupStatus() {
    if (signupStatus) signupStatus.hidden = true;
  }
  function closePopup() {
    if (!popupOpen || !popupFormId) return;
    const form = document.querySelector(`[data-testid="klaviyo-form-${popupFormId}"]`);
    form?.closest('[role="dialog"]')?.querySelector('button[aria-label="Close dialog"]')?.click();
  }
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail;
    if (!detail) return;
    if (detail.formId === popupFormId) {
      if (detail.type === 'open') {
        popupPending = false;
        popupOpen = true;
        clearTimeout(loadTimer);
        hideSignupStatus();
        // The SDK may finish loading after the visitor turns the session test off.
        if (!enabled() || !rules.active() || accessGranted()) closePopup();
      } else if (detail.type === 'close') {
        popupPending = false;
        popupOpen = false;
        clearTimeout(loadTimer);
        dismiss();
      }
    }
    if (detail.type !== 'submit' || !giftFormIds.includes(detail.formId)) return;
    const value = detail.metaData?.email || detail.metaData?.$email;
    if (typeof value !== 'string' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return;
    try { sessionStorage.setItem(emailKey, JSON.stringify({ email: value, savedAt: Date.now() })); } catch {}
    const gift = giftProfiles[detail.formId];
    if (gift && typeof window.klaviyo?.identify === 'function') {
      try {
        Promise.resolve(window.klaviyo.identify({ email: value, 'Black Gift Choice': gift[0], 'Black Gift Name': gift[1], 'Black Gift Campaign': '2026-11' })).catch(() => {});
      } catch {}
    }
    dismiss();
    popupPending = false;
    clearTimeout(loadTimer);
    hideSignupStatus();
    render();
  });
  async function openSignup(manual = false) {
    if (!signup || !popupFormId || !enabled() || !rules.active() || popupOpen || popupPending || accessGranted()) return false;
    let dismissed = false;
    try { dismissed = Date.now() - Number(localStorage.getItem(popupKey) || 0) < 7 * 24 * 60 * 60 * 1000; } catch {}
    if (!manual && (dismissed || document.querySelector('misaki-black-gift-preview') || /\/cart\/?$/.test(location.pathname))) return false;
    if (opening || document.visibilityState !== 'visible' || anotherDialogVisible()) return true;
    opening = true;
    try {
      const identified = manual ? false : await Promise.race([
        new Promise(resolve => {
          if (typeof window.klaviyo?.isIdentified === 'function') window.klaviyo.isIdentified(resolve);
          else { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['isIdentified', resolve]); }
        }),
        new Promise(resolve => setTimeout(() => resolve(null), 3000))
      ]);
      if (!enabled() || !rules.active() || popupOpen || popupPending || accessGranted() || identified === true) return false;
      if (identified !== false || document.visibilityState !== 'visible' || anotherDialogVisible()) return true;
      popupPending = true;
      hideSignupStatus();
      clearTimeout(loadTimer);
      loadTimer = setTimeout(() => {
        if (!popupPending) return;
        popupPending = false;
        if (!enabled() || !rules.active() || accessGranted()) return;
        if (manual && signupStatus) {
          signupStatus.hidden = false;
          signupStatus.textContent = 'Das Anmeldeformular ist derzeit nicht verfügbar. Bitte laden Sie die Seite erneut oder versuchen Sie es später nochmals.';
        } else if (signup.dataset.autoEnabled === 'true') {
          popupTimer = setTimeout(attemptPopup, 10000);
        }
      }, 10000);
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', popupFormId]);
      return false;
    } catch {
      popupPending = false;
      clearTimeout(loadTimer);
      if (manual && signupStatus) {
        signupStatus.hidden = false;
        signupStatus.textContent = 'Das Anmeldeformular ist derzeit nicht verfügbar. Bitte laden Sie die Seite erneut oder versuchen Sie es später nochmals.';
      }
      return true;
    } finally { opening = false; }
  }
  async function attemptPopup() {
    const retry = await openSignup();
    if (retry && enabled() && signup?.dataset.autoEnabled === 'true') popupTimer = setTimeout(attemptPopup, 10000);
  }
  function schedulePopup() {
    clearTimeout(popupTimer);
    if (enabled() && signup?.dataset.autoEnabled === 'true') popupTimer = setTimeout(attemptPopup, 8000);
  }
  document.querySelectorAll('[data-black-gift-test-toggle]').forEach(button => button.addEventListener('click', () => {
    try {
      if (enabled()) sessionStorage.removeItem(testKey);
      else sessionStorage.setItem(testKey, 'true');
    } catch {
      button.closest('[data-black-gift-session-test]').querySelector('[data-black-gift-test-status]').textContent = 'Der Sitzungstest konnte nicht gespeichert werden. Bitte erlauben Sie die Speicherung für diese Website.';
      return;
    }
    if (!enabled()) {
      clearTimeout(loadTimer);
      popupPending = false;
      hideSignupStatus();
      closePopup();
    }
    render();
    schedulePopup();
    window.MisakiBlackGiftCart?.refresh();
  }));
  document.addEventListener('click', event => {
    const entry = event.target.closest('[data-black-gift-open-signup]');
    if (entry) { openSignup(true); return; }
    const link = event.target.closest('[data-gift-link]');
    if (link?.getAttribute('aria-disabled') === 'true') event.preventDefault();
  });
  schedulePopup();
  window.MisakiBlackGiftCampaign = { email, prefill, openSignup, accessGranted };
  render();
})();
